/* eslint-disable */
import saveStoreDraft from "../../utils/saveStoreDraft";
import { useTranslation as useUiTranslation } from "react-i18next";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import QuillEditor from "./TextEditor";
import { doc } from "firebase/firestore";
import { db } from "../../firebase";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { useSelector } from "react-redux";
import apicache from "../../components/clearCach/clear";

const Model2 = ({ show, setShow, data, setData }) => {
  const { t: uiT } = useUiTranslation();
  const MySwal = withReactContent(Swal);
  const products = useSelector((state) => state.ProductsReducer);
  const store = useSelector((state) => state.StoreReducer);
  const account = useSelector((state) => state.AccountReducer);

  const handleClose = () =>
    setShow({
      model1: false,
      model2: false,
      model3: false,
    });

  const handleSubmit = async (e) => {
    e.preventDefault();
    apicache(account, products);
    try {
      await saveStoreDraft(doc(db, "store", data.id), store, data);
      Swal.fire({
        icon: "success",
        title: uiT("settings.success"),
        confirmButtonText: uiT("ship.ok"),
        confirmButtonColor: "rgb(141, 93, 167)",
      });
    } catch (error) {
      Swal.fire({ icon: "error", title: uiT("ui.notSaved"), confirmButtonText: uiT("ship.ok") });
    }
  };

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        size="lg"

        className="w-100"
      >
        <Modal.Header>
          <Modal.Title>{uiT("ui.returnsPolicy")}</Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleSubmit}>
          <Modal.Body>
            <QuillEditor data={data} setData={setData} type={"return"} />
          </Modal.Body>
          <Modal.Footer>
            <Button variant="success" type="submit">
              {uiT("common.save")}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
};

export default Model2;
